import DashboardBlock from './DashboardBlock';

export { DashboardBlock };
